var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page flex flex-col w-1600px m-auto bg-white"},[(_vm.page === 'lists')?_c('lists',{ref:"lists",on:{"listClick":_vm.listClick}}):_vm._e(),(_vm.page === 'detail')?_c('detail',{attrs:{"data":_vm.discussData},on:{"back":function($event){_vm.page = 'lists'}}}):_vm._e(),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }